


export default function ProofSection() {
  const proofs = [
    {
      app: 'Freecash',
      amount: '60,57€',
      date: '28. Dez 2024',
      method: 'Bitcoin',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/9bb0c5801b373a7e202cd0be5b585bf5.png'
    },
    {
      app: 'Freecash',
      amount: '$190.00',
      date: '24. Okt 2024',
      method: 'PayPal',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/8227d4f897c4ccf3dfc2871f35f7c34c.png'
    },
    {
      app: 'Freecash',
      amount: '$95.00',
      date: '18. Okt 2024',
      method: 'PayPal',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/0ef7e306ab29c0ee84e48b5f5cb7e394.png'
    },
    {
      app: 'Scrambly',
      amount: '$30.00',
      date: '24. Sep 2024',
      method: 'PayPal',
      image: 'https://static.readdy.ai/image/50172c35d199b0f1b57a44755da07512/fa1c8b692677451f94750ad8f54be09f.png'
    }
  ];

  return (
    <section className="py-20 bg-gray-800/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Echte Auszahlungsbeweise
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Keine Photoshop-Tricks, keine gefälschten Screenshots. Hier sind echte Auszahlungen aus den letzten Wochen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {proofs.map((proof, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl overflow-hidden hover:border-teal-400/50 transition-all duration-300 group"
            >
              <div className="aspect-video bg-gray-700 relative overflow-hidden">
                <img 
                  src={proof.image}
                  alt={`Auszahlungsbeweis ${proof.app}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 right-4 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
                  Verifiziert
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-lg font-semibold text-white">{proof.app}</h3>
                  <span className="text-teal-400 font-bold text-lg">{proof.amount}</span>
                </div>
                
                <div className="flex justify-between text-sm text-gray-400">
                  <span>{proof.date}</span>
                  <span>{proof.method}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-3xl font-bold text-teal-400 mb-2">$14,400</div>
            <div className="text-gray-400">Gesamt ausgezahlt</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-teal-400 mb-2">127</div>
            <div className="text-gray-400">Erfolgreiche Auszahlungen</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-teal-400 mb-2">23</div>
            <div className="text-gray-400">Getestete Apps</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-teal-400 mb-2">98%</div>
            <div className="text-gray-400">Erfolgsrate</div>
          </div>
        </div>

      </div>
    </section>
  );
}
